import React from 'react';
import { styled } from '@mui/material/styles';
import { Typography, Button, Paper } from '@mui/material';

const PREFIX = 'ErrorBoundary';

const classes = {
  root: `${PREFIX}-root`,
  paper: `${PREFIX}-paper`,
  title: `${PREFIX}-title`,
  message: `${PREFIX}-message`,
  button: `${PREFIX}-button`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    padding: theme.spacing(2)
  },

  [`& .${classes.paper}`]: {
    padding: theme.spacing(3),
    textAlign: 'center',
    maxWidth: 600
  },

  [`& .${classes.title}`]: {
    marginBottom: theme.spacing(2),
    color: theme.palette.error.main
  },

  [`& .${classes.message}`]: {
    marginBottom: theme.spacing(3)
  },

  [`& .${classes.button}`]: {
    margin: theme.spacing(1)
  }
}));

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    
    // You can also log the error to an error reporting service here
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoBack = () => {
    window.history.back();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Root className={classes.root}>
          <Paper className={classes.paper} elevation={3}>
            <Typography variant="h5" component="h2" className={classes.title}>
              Something went wrong
            </Typography>
            <Typography variant="body1" className={classes.message}>
              We apologize for the inconvenience. You can try reloading the page or going back to the previous page.
            </Typography>
            {this.state.error && (
              <Typography variant="body2" color="error" gutterBottom>
                Error: {this.state.error.toString()}
              </Typography>
            )}
            <div>
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleReload}
                className={classes.button}
              >
                Reload Page
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={this.handleGoBack}
                className={classes.button}
              >
                Go Back
              </Button>
            </div>
          </Paper>
        </Root>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;